import { useState } from "react";

import { useEditAgreementMutation } from "@modules/agreements/services/mutations";
import { ActiveAgreementSwitchProps } from "./types";

export function useActiveAgreementSwitch({
  id,
  value,
}: ActiveAgreementSwitchProps) {
  const [isActive, setIsActive] = useState<boolean>(value);

  const { mutateAsync, isPending } = useEditAgreementMutation(id);

  const toggle = async () => {
    await mutateAsync({
      active: !isActive,
    });
    setIsActive((prev) => !prev);
  };

  return { isActive, isPending, toggle };
}

export function useActiveBestSellerAgreementSwitch({
  id,
  value,
}: ActiveAgreementSwitchProps) {
  const [isActive, setIsActive] = useState<boolean>(value);

  const { mutateAsync, isPending } = useEditAgreementMutation(id);

  const toggle = async () => {
    await mutateAsync({
      show_best_sellers: !isActive,
    });
    setIsActive((prev) => !prev);
  };

  return { isActive, isPending, toggle };
}
